<app-loading *ngIf="isLoading"></app-loading>
<div class="overlay">
  <div class="overlay-content">
    <svg class="logo" data-name="Gruppe 192" height="102.994" id="Gruppe_192"
         viewBox="0 0 185.386 102.994" width="185.386" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <clipPath id="clip-path">
          <rect data-name="Rechteck 76" fill="none" height="102.994" id="Rechteck_76" width="185.386"/>
        </clipPath>
      </defs>
      <rect data-name="Rechteck 73" fill="#023e84" height="102.994" id="Rechteck_73" width="185.386"/>
      <g data-name="Gruppe 191" id="Gruppe_191">
        <g clip-path="url(#clip-path)" data-name="Gruppe 190" id="Gruppe_190">
          <path
            d="M115.7,40.732l-.117-.6a132.649,132.649,0,0,1-22.892,1.98A132.65,132.65,0,0,1,69.8,40.137l-.115.6a108.578,108.578,0,0,0,23,2.448A108.615,108.615,0,0,0,115.7,40.732"
            data-name="Pfad 86"
            fill="#fff"
            id="Pfad_86"/>
          <path
            d="M125.3,43.714l-.118-.592a177.093,177.093,0,0,1-32.49,2.993,176.634,176.634,0,0,1-32.489-3l-.119.6a154.184,154.184,0,0,0,32.608,3.465A154.324,154.324,0,0,0,125.3,43.714"
            data-name="Pfad 87"
            fill="#fff"
            id="Pfad_87"/>
          <path
            d="M106.456,37.863l-.1-.6a109.529,109.529,0,0,1-13.669.852,109.37,109.37,0,0,1-13.671-.852l-.1.6a71.723,71.723,0,0,0,13.766,1.321,72.113,72.113,0,0,0,13.767-1.321"
            data-name="Pfad 88"
            fill="#fff"
            id="Pfad_88"/>
          <path
            d="M91.509,17.283c-2.719,0-4.923,2.136-4.923,5.575V34.587H88.05V22.879c0-2.982,1.808-4.7,4.043-4.7a3.95,3.95,0,0,1,3.957,4.061h.295a4.815,4.815,0,0,0-4.836-4.96"
            data-name="Pfad 89"
            fill="#fff"
            id="Pfad_89"/>
          <path
            d="M91.509,16.378c3.215,0,5.821,2.318,5.821,6.48v11.73h1.463V22.763c0-4.624-3.067-7.315-6.619-7.315a6.586,6.586,0,0,0-5.806,3.476l.23.125a5.816,5.816,0,0,1,4.911-2.671"
            data-name="Pfad 90"
            fill="#fff"
            id="Pfad_90"/>
          <path
            d="M96.5,80.783h-.635l-3.324,4.273v.472h2.912v1.839H96.5V85.528h1.046v-.665H96.5Zm-1.047,4.08H93.071l2.378-3.108Z"
            data-name="Pfad 91"
            fill="#fff"
            id="Pfad_91"/>
          <path
            d="M103.824,83.671c.657-.26,1.452-.684,1.452-1.415,0-.925-1.155-1.386-2.023-1.386-1.1,0-2.3.528-2.3,1.6,0,.859.585,1.243,1.356,1.6-.784.4-1.5.838-1.5,1.752,0,1.136,1.07,1.627,2.076,1.627,1.422,0,2.619-.607,2.619-1.85,0-1.018-.718-1.519-1.681-1.924m-1.9-1.472c0-.722.587-1.071,1.35-1.071.722,0,1.236.377,1.236,1.078a1.491,1.491,0,0,1-.885,1.389c-.627-.327-1.7-.6-1.7-1.4m1.109,4.988a1.277,1.277,0,0,1-1.392-1.331,1.881,1.881,0,0,1,.9-1.693c.847.374,1.973.654,1.973,1.693a1.351,1.351,0,0,1-1.484,1.331"
            data-name="Pfad 92"
            fill="#fff"
            id="Pfad_92"/>
          <path
            d="M81.524,86.7V80.87h-.18a3.8,3.8,0,0,1-1.926.992v.2c.594.051.879.051.974.2a1.3,1.3,0,0,1,.083.6V86.7c0,.413-.228.47-.777.47v.193H82.24v-.193c-.566,0-.716-.057-.716-.47"
            data-name="Pfad 93"
            fill="#fff"
            id="Pfad_93"/>
          <path
            d="M86.719,80.937c-.221-.01-.3-.031-.3-.268h-.167l-.66,1.809h.234l.1-.269a.426.426,0,0,1,.407-.344h2.818l-2.07,4.146c-.383.749-.659,1.309-.659,1.347,0,.191.286.184.434.184a.627.627,0,0,0,.684-.454l2.329-5.871v-.26H87.534c-.264,0-.54,0-.815-.02"
            data-name="Pfad 94"
            fill="#fff"
            id="Pfad_94"/>
          <rect data-name="Rechteck 74" fill="#fff" height="0.601" id="Rechteck_74"
                transform="translate(22.058 74.185)" width="62.238"/>
          <rect data-name="Rechteck 75" fill="#fff" height="0.601" id="Rechteck_75"
                transform="translate(91.081 74.185)" width="73.707"/>
          <path
            d="M74.051,66.018a4.545,4.545,0,0,0,4.838,4.64,4.681,4.681,0,0,0,4.839-4.64,4.492,4.492,0,0,0-4.839-4.64,4.54,4.54,0,0,0-4.838,4.64m7.621,0c0,2.281-.952,4.144-2.783,4.144-1.89,0-2.781-1.844-2.781-4.144s.962-4.144,2.781-4.144c1.973,0,2.783,1.836,2.783,4.144"
            data-name="Pfad 95"
            fill="#fff"
            id="Pfad_95"/>
          <path
            d="M117.2,56.329v.429c.9.143,1.664-.062,1.664.982V69.126c0,.835-.9.835-1.664.875v.433c1.707,0,3.47.081,5.246.081a10.341,10.341,0,0,0,4.538-.778,3.428,3.428,0,0,0,2.123-3.168,3.786,3.786,0,0,0-3.669-3.72,3.194,3.194,0,0,0,2.692-3.229,3.017,3.017,0,0,0-1.731-2.7,9.738,9.738,0,0,0-4.267-.634c-1.686.021-3.315.021-4.932.041m9.564,10.343c0,2.111-1.243,3.268-3.824,3.268-1.1,0-1.843-.184-1.843-1.248V63.455h.948c2.494,0,4.719.212,4.719,3.217m-.829-6.869c0,2.25-1.756,3.077-3.782,3.077h-1.056V56.863c.2-.008.532,0,.732,0,3.322,0,4.106,1.333,4.106,2.94"
            data-name="Pfad 96"
            fill="#fff"
            id="Pfad_96"/>
          <path
            d="M136.527,70.659a4.684,4.684,0,0,0,4.838-4.641,4.492,4.492,0,0,0-4.838-4.64,4.645,4.645,0,1,0,0,9.281m0-8.785c1.972,0,2.784,1.837,2.784,4.144,0,2.281-.953,4.144-2.784,4.144-1.89,0-2.782-1.844-2.782-4.144s.961-4.144,2.782-4.144"
            data-name="Pfad 97"
            fill="#fff"
            id="Pfad_97"/>
          <path
            d="M27.752,70.72H28.5L32.862,59.4c.512-1.33,1.035-2.637,2.544-2.637v-.43H30.653v.43c.505,0,1.2-.044,1.57.636.2.37.147,1.145-.388,2.593l-2.858,7.727h-.046L25.4,58.843a2.981,2.981,0,0,1-.209-1.264c.142-.636.92-.82,1.671-.82v-.43H20.6v.43a2.142,2.142,0,0,1,1.424.529,7.651,7.651,0,0,1,1.155,2.272Z"
            data-name="Pfad 98"
            fill="#fff"
            id="Pfad_98"/>
          <path
            d="M46.578,70.045c-.945-.061-1.238-.061-1.238-1.125V56.145c-.989.286-2.218.694-3.275.942v.244a1.58,1.58,0,0,1,.967.307,1.693,1.693,0,0,1,.314,1.288V68.92c0,1.064-.291,1.064-1.3,1.125v.39h4.535Z"
            data-name="Pfad 99"
            fill="#fff"
            id="Pfad_99"/>
          <path
            d="M53.049,70.045c-.944-.061-1.237-.061-1.237-1.125V56.145c-.989.286-2.218.694-3.276.942v.244a1.581,1.581,0,0,1,.968.307,1.689,1.689,0,0,1,.315,1.288V68.92c0,1.064-.293,1.064-1.3,1.125v.39h4.534Z"
            data-name="Pfad 100"
            fill="#fff"
            id="Pfad_100"/>
          <path
            d="M70.5,62.4c.585,0,.809.809,1.49.809a.915.915,0,0,0,.926-.923c0-.666-.685-1.05-1.335-1.05a3.243,3.243,0,0,0-2.638,1.837V61.318c-.922.326-2,.753-2.946,1.039v.206c.786.345,1.032.388,1.032,1.187v5.169c0,1.064-.29,1.064-1.257,1.125v.39h4.655v-.39c-1.145-.061-1.439-.061-1.439-1.125V64.976c0-1.669.846-2.578,1.512-2.578"
            data-name="Pfad 101"
            fill="#fff"
            id="Pfad_101"/>
          <path
            d="M148.376,70.659a4.084,4.084,0,0,0,3.893-2.584l-.335-.1a3.381,3.381,0,0,1-2.855,1.91c-2.414,0-3.031-2.105-3.031-3.987,0-1.636.478-4.024,2.556-4.024a1.548,1.548,0,0,1,1.689,1.424.967.967,0,0,0,.9,1.023.827.827,0,0,0,.868-.837c-.053-1.336-1.708-2.106-3.486-2.106a4.485,4.485,0,0,0-4.68,4.727,4.366,4.366,0,0,0,4.477,4.554"
            data-name="Pfad 102"
            fill="#fff"
            id="Pfad_102"/>
          <path
            d="M158.323,70.045c-.943-.061-1.238-.061-1.238-1.125V63.505a2.864,2.864,0,0,1,2.363-1.29c1.247,0,1.92,1.026,1.92,2.383V68.92c0,1.064-.294,1.064-1.218,1.125v.39h4.492v-.39c-.99-.061-1.28-.061-1.28-1.125V64.812c0-2.914-2.077-3.434-3.189-3.434a4.2,4.2,0,0,0-3.088,1.453V56.145c-.965.348-2.172.675-3.138,1.043v.164c.584.122,1.145.305,1.145.939V68.92c0,1.064-.293,1.064-1.3,1.125v.39h4.534Z"
            data-name="Pfad 103"
            fill="#fff"
            id="Pfad_103"/>
          <path
            d="M38.637,61.278c-1.013.346-2.279.712-3.245,1.08v.2a2.293,2.293,0,0,1,.809.205c.4.246.4.816.4,1.247v4.9c0,1.065-.291,1.065-1.3,1.126v.39h4.571v-.39c-.944-.061-1.236-.061-1.236-1.126Z"
            data-name="Pfad 104"
            fill="#fff"
            id="Pfad_104"/>
          <path d="M37.527,59.772a1.157,1.157,0,1,0-1.158-1.156,1.158,1.158,0,0,0,1.158,1.156" data-name="Pfad 105"
                fill="#fff" id="Pfad_105"/>
          <path
            d="M59.919,70.659a4.169,4.169,0,0,0,3.887-2.584l-.383-.1a3.662,3.662,0,0,1-2.916,1.91c-2.386,0-3.142-1.844-3.142-3.987a6.951,6.951,0,0,1,.077-1.055h6.316a3.607,3.607,0,0,0-3.925-3.465,4.517,4.517,0,0,0-4.615,4.727,4.446,4.446,0,0,0,4.7,4.554M59.9,61.881c.935,0,1.861.8,1.861,2.347H57.57c.383-1.438,1.264-2.347,2.325-2.347"
            data-name="Pfad 106"
            fill="#fff"
            id="Pfad_106"/>
          <path
            d="M86.313,63.054l3.545,7.6-.715,1.654c-.183.42-.475,1.028-1.021.98-.247-.019-.473-.1-.72-.121a.8.8,0,0,0-.855.837.9.9,0,0,0,.927.817c1.282,0,1.8-1.2,2.21-2.144l4.092-9.444a1.63,1.63,0,0,1,1.67-1.248V61.6H91.757v.386c.379,0,.992-.026,1.256.389a1.586,1.586,0,0,1-.124,1.288l-2.029,4.68-2.234-5.171a1.08,1.08,0,0,1-.075-.787c.143-.392.62-.4,1.07-.4V61.6h-4.7v.386c.831,0,1.122.5,1.389,1.064"
            data-name="Pfad 107"
            fill="#fff"
            id="Pfad_107"/>
          <path
            d="M100.676,67.681a3.008,3.008,0,0,0,3.366,2.978,4.293,4.293,0,0,0,3.065-1.448l.167.176a3.663,3.663,0,0,0,2.8,1.272,3.443,3.443,0,0,0,2.5-1.72l-.25-.217a1.75,1.75,0,0,1-1.5.8,3.175,3.175,0,0,1-2.419-1.261c-.095-.11-.2-.23-.3-.361.07-.114.136-.23.2-.343a19.694,19.694,0,0,0,.918-1.908c.35-.924.868-1.9,2-1.921V63.4h-3.406v.333c.585,0,.985.184.985.819a5.8,5.8,0,0,1-.923,2.661c-.033.058-.076.137-.137.229a46.163,46.163,0,0,1-2.589-4c1.018-.73,2.13-1.548,2.21-2.6.092-1.214-.782-2.063-2.4-2.063a2.373,2.373,0,0,0-2.6,2.4,5.09,5.09,0,0,0,.57,1.824c.105.215.294.563.541.99-1.235.849-2.8,1.953-2.8,3.7M105,59.232c.663,0,1.254.393,1.16,1.512a3.164,3.164,0,0,1-1.291,2.194c-.169-.3-.308-.563-.4-.757a3.749,3.749,0,0,1-.572-1.805A1.22,1.22,0,0,1,105,59.232m-1.211,5.28a36.7,36.7,0,0,0,2.9,4.221,3.111,3.111,0,0,1-2.078.951,2.215,2.215,0,0,1-2.175-2.343,3.937,3.937,0,0,1,1.348-2.829"
            data-name="Pfad 108"
            fill="#fff"
            id="Pfad_108"/>
        </g>
      </g>
    </svg>
    <router-outlet></router-outlet>
  </div>
</div>
